import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} en {{waitingTime}} min',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Entrega',
    [ORDER_METHODS.PICKUP]: 'Recogida',
    [ORDER_METHODS.ROOM_SERVICE]: 'Servicio a la habitación',
  },
};
